module.exports = __webpack_public_path__ + "img/chiku03.c2eb203c.png";